export * from './LandingPage';
export * from './About';
export * from './Skill';
export * from './Project';
export * from './Contact';


// WEBPACK FOOTER //
// ./src/components/Pages/index.js